module.exports = __webpack_public_path__ + "assets/img/hbgd2.93eb6729.png";